import NavBar from "@/components/navbar";
import { useConfigPage } from "@/hooks/useConfigPage/useConfigPage";
import { getBrowserEnv } from "@/utils/tools";

const AppNavBarWithConfig = ({ onBack }: { onBack?: () => void }) => {
  const { isXPApp } = getBrowserEnv();
  const { configPageQuery, setNavHeight, onNavShareClick } = useConfigPage();

  if (!isXPApp) return null;

  return (
    <NavBar
      title={configPageQuery?.data?.pageTitle}
      showShare={isXPApp && configPageQuery?.data?.canShare !== 0}
      navLoad={({ navHeight }) => {
        setNavHeight?.(navHeight);
      }}
      onBack={onBack}
      onClickRight={onNavShareClick}
    />
  );
};

export default AppNavBarWithConfig;
